// containers/EstimatesAdmin/parts/EditorActions.jsx
import React from 'react';

export default function EditorActions({
    pdfBusy,
    hasPdf,
    onMakePdf,
    onOpenLastPdf,
    onSaveHTML,
    onExportJSON,
    onImportJSON,
    onClearAll,
}) {
    return (
        <div className="card">
            <div className="actions stack-mobile">
                <button className="good" onClick={onMakePdf} disabled={pdfBusy}>
                    {pdfBusy ? 'Формируем…' : 'PDF'}
                </button>
                {hasPdf && <button className="ghost" onClick={onOpenLastPdf}>Открыть последний PDF</button>}
                <button className="flat" onClick={onSaveHTML}>Скачать HTML (со состоянием)</button>
                <button className="ghost" onClick={onExportJSON}>Экспорт JSON</button>
                <button className="ghost" onClick={onImportJSON}>Импорт JSON</button>
                <button className="danger" onClick={onClearAll}>Очистить всё</button>
            </div>
        </div>
    );
}
